import React, { Component } from "react";
import axios from "axios";
import { addDays } from "date-fns";
import { CreateExpense } from "../Maintenance/CreateExpense";
import CustomDialog from "../../Components/common/Dialog";
import instance from "../../axios";
import { errorHandler } from "../../Helpers";
import { setCities } from "../../Actions/Cities";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import Loader from "../../Layout/Loader";
import { initiateBookingTapPayment } from "../Payments/tapPaymentHelpers";
import { connect } from "react-redux";

const CancelToken = axios.CancelToken;
let source;

const buildDefaultForm = (garageNumber = "") => ({
  name: "",
  description: "",
  contactNumber: "966",
  contractNumber: "",
  odometer: "",
  workOrderNumber: "",
  serviceTime: new Date(),
  expireTime: addDays(new Date(), 7),
  quantity: "",
  cost: "",
  address: "",
  coordinates: "",
  service: "Service",
  type: "",
  driver: "",
  vehicles: "",
  device: "",
  status: "",
  files: "",
  engineHours: "",
  currentEngineHours: 0,
  currentOdometer: 0,
  areaId: [],
  attributes: {
    updateMaintenance: false,
    mileage: 0,
    hours: 0,
    date: 0,
    status: true,
    mailTo: "",
    email: [],
    notificators: "mail,whatsapp",
  },
  garageNumber: garageNumber || "",
  createdBy: true,
  prePaid: false,
});

const DataFormat = (
  data,
  totalCost,
  totalQuantity,
  serviceData,
  account,
  customerType,
) => ({
  service: {
    id: data?.id || 0,
    contractNumber:
      data?.contractNumber?.contractNumber || data?.contractNumber || "",
    updatedBy: data?.updatedBy || "",
    status: data?.status
      ? data.status
      : customerType === 1
        ? "GarageInitiate"
        : customerType === 2
          ? "OpToCustomer"
          : "required",
    name: data?.name || "",
    description: data?.description || null,
    workOrderNumber: data?.workOrderNumber || "",
    contactNumber: data?.contactNumber || 0,
    odometer: data?.odometer ? parseFloat(data.odometer) : 0,
    quantity: totalQuantity || "",
    cost: totalCost || "",
    address: data?.address || null,
    coordinate: data?.coordinates || "30.00,50.00",
    vehicleId: data?.vehicles?.id ? parseInt(data.vehicles.id, 10) : "",
    garageId: data?.garage?.id || null,
    vehicleLicensePlate:
      data?.vehicles?.vehicleLicensePlate ||
      data?.vehicles?.vehicleLP ||
      data?.vehicleLicensePlate ||
      "",
    garageNumber: data?.garage?.garageNumber || data?.garageNumber || null,
    deviceId: data?.deviceId || "",
    driverUniqueId: data?.driver?.uniqueId || null,
    maintenanceId: data?.maintenanceId || "",
    files: data?.files || "",
    createdTime: data?.createdTime || "",
    serviceTime: data?.serviceTime || "",
    expireTime: data?.expireTime || "",
    userId: account?.userId || 1,
    engineHours: data?.engineHours
      ? parseInt(data.engineHours, 10) * (1000 * 3600)
      : 0,
    tag1: data?.tag1 || "",
    tag2: data?.tag2 || "",
    tag3: data?.tag3 || "",
    refNum: data?.refNum || "",
    refdate: data?.refdate || "",
    areaId: data?.areaId?.id || data?.areaId?.key || "",
    attributes: data?.attributes
      ? (() => {
          const attrs = { ...data.attributes };
          delete attrs.image;
          return attrs;
        })()
      : {},
    invoiceType: account?.contractType || "",
    workOrderHistoryID: "",
    prePaid:
      data?.prePaid === true ||
      data?.prePaid === "true" ||
      data?.prePaid === 1 ||
      data?.prePaid === "1" ||
      data?.prepaid === true ||
      data?.prepaid === "true" ||
      data?.prepaid === 1 ||
      data?.prepaid === "1",
  },
  serviceExpenseCollection: [...serviceData],
});

const buildFleetRefNum = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return parseInt(
    `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(
      d.getHours(),
    )}${pad(d.getMinutes())}${pad(d.getSeconds())}`,
    10,
  );
};

const mapSubTypeOption = (item) => ({
  key: item.id,
  id: item.id,
  expenseTypeId: item.expenseTypeId,
  parentId: item.parentId,
  unitPrice: item.unitPrice,
  itemCode: item.subTypeNum,
  expenseType: item.expenseType,
  label: `${item.label} - ${item.subTypeNum}`,
  name: item.label,
});

/**
 * Opens CreateExpense (already modal-wrapped) for a PMS prediction row.
 * Vehicle is locked; name defaults to "Scheduled booking - {itemCode}".
 */
class ScheduleBookingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isVisible: true,
      loader: false,
      zerovat: false,
      issueinvoice: false,
      isValidVehicle: true,
      selectedCityId: null,
      expenseForm: buildDefaultForm(props.ServerSetting?.garageNumber),
      serviceExpenseCollection: [
        {
          quantity: "1",
          cost: "1",
          expenseSubTypeId: "",
          expenseTypeId: "",
          selectedSubTypes: [],
        },
      ],
      expenseTypes: [],
      garageList: [],
      drivers: [],
      vehicles: [],
    };
  }

  componentDidMount() {
    this.bootstrap();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.prediction?.id !== this.props.prediction?.id ||
      prevProps.group?.plateNumber !== this.props.group?.plateNumber
    ) {
      this.bootstrap();
    }
  }

  bootstrap = async () => {
    this.setState({ loading: true });
    try {
      // Dashboard uses Layout noSidebar, so CommonSection never loads Cities.
      await this.ensureCitiesLoaded();
      await Promise.all([
        this.getExpenseTypes(),
        this.getGarageList(),
        this.resolveVehicleAndForm(),
      ]);
      await this.applyPredictionServiceDefaults();
    } catch (e) {
      // errors handled per call
    } finally {
      this.setState({ loading: false }, () => this.checkRequiredFields());
    }
  };

  ensureCitiesLoaded = async () => {
    if (Array.isArray(this.props.cities) && this.props.cities.length) {
      return;
    }
    try {
      const response = await instance({
        url: `/api/citys/get?limit=-1`,
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const rows = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response)
          ? response
          : [];
      const updateCities = rows.map((item) => ({
        ...item,
        name: item?.cityEn || item?.region,
        label: item?.cityEn || item?.region,
      }));
      if (updateCities.length) {
        this.props.dispatch(setCities(updateCities));
      }
    } catch (error) {
      // City dropdown stays empty; rest of booking can still proceed
    }
  };

  getPlate = () =>
    this.props.group?.plateNumber ||
    this.props.group?.plateNo ||
    this.props.prediction?.plateNumber ||
    this.props.prediction?.plateNo ||
    "";

  getDefaultName = () => {
    const code =
      this.props.prediction?.itemCode ||
      this.props.prediction?.categoryName ||
      "";
    return `Scheduled booking - ${code}`.trim();
  };

  getPredictionFormDefaults = () => {
    const prediction = this.props.prediction || {};
    const dueOdometer =
      prediction.nextOdometerReading ??
      prediction.dueOdometer ??
      prediction.nextOdometer ??
      "";
    return {
      ...buildDefaultForm(this.props.ServerSetting?.garageNumber),
      name: this.getDefaultName(),
      description: "predictive based service",
      refdate: new Date(),
      refNum: buildFleetRefNum(),
      odometer: dueOdometer === 0 || dueOdometer ? dueOdometer : "",
    };
  };

  // The vehicles in redux are only the current page (~50), so never match
  // against that list — always resolve the vehicle from the API.
  fetchVehicleById = async (vehicleId) => {
    if (!vehicleId) return null;
    try {
      const res = await instance({
        method: "GET",
        url: `/api/vehicles/get?vehicleId=${encodeURIComponent(vehicleId)}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const list = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res)
          ? res
          : [];
      return (
        list.find((v) => String(v.id) === String(vehicleId)) || list[0] || null
      );
    } catch (error) {
      errorHandler(error, this.props.dispatch);
      return null;
    }
  };

  fetchVehicleByPlate = async (plate) => {
    if (!plate) return null;
    try {
      const res = await instance({
        method: "GET",
        url: `/api/vehicles/get?page=1&limit=20&search=${encodeURIComponent(
          plate,
        )}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const list = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res)
          ? res
          : [];
      const target = String(plate).trim().toLowerCase();
      return (
        list.find(
          (v) =>
            String(v.vehicleLicensePlate || "")
              .trim()
              .toLowerCase() === target,
        ) || null
      );
    } catch (error) {
      errorHandler(error, this.props.dispatch);
      return null;
    }
  };

  resolveVehicleAndForm = async () => {
    const prediction = this.props.prediction || {};
    const plate = this.getPlate();

    let vehicle = await this.fetchVehicleById(prediction.vehicleId);
    if (!vehicle) {
      vehicle = await this.fetchVehicleByPlate(plate);
    }

    if (!vehicle) {
      this.props.dispatch(notifyError("invalidVehicle"));
      return null;
    }

    const make = vehicle.attributes?.make || "";
    const model = vehicle.attributes?.model || "";
    const arabicPlate = vehicle.vehicleLisencePlateArabic || "";
    const label = `${vehicle.vehicleLicensePlate}  ${make} ${model}  ${arabicPlate}`;
    const vehicleOption = {
      id: vehicle.id,
      value: vehicle.id,
      label,
      vehicleLP: vehicle.vehicleLicensePlate,
      vehicleLicensePlate: vehicle.vehicleLicensePlate,
    };

    await new Promise((resolve) => {
      this.setState(
        {
          vehicles: [vehicleOption],
          expenseForm: {
            ...this.getPredictionFormDefaults(),
            vehicles: vehicleOption,
            vehicleLicensePlate: vehicle.vehicleLicensePlate,
            isValidVehicle: true,
          },
          isValidVehicle: true,
        },
        resolve,
      );
    });

    this.getVehiclesData(vehicle.id, null, true);
    this.getDriverByVehicleId(vehicle.id);
    return vehicleOption;
  };

  getVehiclesData = (id, date, preserveOdometer = false) => {
    if (!id) return;
    const url = date
      ? `/api/vehicles/${id}/accumulator?date=${date}`
      : `/api/vehicles/${id}/accumulator`;
    instance({
      method: "GET",
      url,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        this.setState(
          (prev) => ({
            expenseForm: {
              ...prev.expenseForm,
              engineHours: response.hours
                ? (response.hours / (1000 * 3600)).toFixed(2) + " h"
                : 0,
              currentOdometer: response.totalDistance || 0,
              ...(preserveOdometer
                ? {}
                : { odometer: response.totalDistance || 0 }),
            },
          }),
          () => this.checkRequiredFields(),
        );
      })
      .catch(() => {});
  };

  getDriverByVehicleId = (id) => {
    if (!id) return;
    instance({
      method: "GET",
      url: `/api/drivers/vehicleid/${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response) return;
        const driver = {
          key: response.id,
          id: response.id,
          label: response.name,
          name: response.name,
          uniqueId: response.uniqueId,
          valueType: "string",
        };
        this.setState(
          (prev) => ({
            expenseForm: {
              ...prev.expenseForm,
              driver,
            },
            drivers: [driver],
          }),
          () => this.checkRequiredFields(),
        );
      })
      .catch(() => {});
  };

  getExpenseTypes = (contractNumber) => {
    const userId = contractNumber
      ? contractNumber
      : this.props.ServerSetting && this.props.ServerSetting.contractNumber;
    return instance({
      method: "GET",
      url: userId
        ? `/api/expensetypes?contractNumber=${userId}`
        : `/api/expensetypes`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        const expenseTypes = (response || []).map((item) => ({
          key: item.id,
          id: item.id,
          name: item.name,
          description: item.description,
          attributes: item.attributes,
          parentId: item.parentId,
          valueType: "string",
          expenseType: item.expenseType,
        }));
        return new Promise((resolve) => {
          this.setState({ expenseTypes }, () => resolve(expenseTypes));
        });
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
        return [];
      });
  };

  fetchSubTypes = async (expenseTypeId, vehicleId, search = "") => {
    if (!expenseTypeId) return [];
    try {
      const response = await instance({
        method: "GET",
        url: `/api/expensetypes/subtype/get?expenseTypeId=${expenseTypeId}&vehicleId=${
          vehicleId || ""
        }&page=1&limit=50&search=${encodeURIComponent(search || "")}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const rows = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response)
          ? response
          : [];
      return rows.map(mapSubTypeOption);
    } catch (e) {
      return [];
    }
  };

  applyPredictionServiceDefaults = async () => {
    const prediction = this.props.prediction || {};
    const categoryName = String(prediction.categoryName || "")
      .trim()
      .toLowerCase();
    const itemCode = String(prediction.itemCode || "").trim();
    if (!categoryName && !itemCode) return;

    const expenseTypes = this.state.expenseTypes || [];
    const matchedType = expenseTypes.find(
      (t) => String(t.name || "").trim().toLowerCase() === categoryName,
    );
    if (!matchedType) return;

    const vehicleId = this.state.expenseForm?.vehicles?.id || "";
    let selectedSubTypes = await this.fetchSubTypes(
      matchedType.id,
      vehicleId,
      itemCode,
    );
    if (!selectedSubTypes.length && itemCode) {
      selectedSubTypes = await this.fetchSubTypes(
        matchedType.id,
        vehicleId,
        "",
      );
    }

    const itemCodeNorm = itemCode.toLowerCase();
    const matchedSubType =
      selectedSubTypes.find(
        (s) =>
          String(s.itemCode || "")
            .trim()
            .toLowerCase() === itemCodeNorm,
      ) ||
      selectedSubTypes.find(
        (s) =>
          String(s.name || "")
            .trim()
            .toLowerCase() === itemCodeNorm ||
          String(s.label || "")
            .trim()
            .toLowerCase()
            .startsWith(itemCodeNorm),
      ) ||
      null;

    const unitPrice = matchedSubType
      ? matchedSubType.unitPrice !== 0
        ? matchedSubType.unitPrice
        : 0
      : 1;

    await new Promise((resolve) => {
      this.setState(
        {
          serviceExpenseCollection: [
            {
              quantity: "1",
              cost: unitPrice || "1",
              expenseTypeId: matchedType,
              expenseSubTypeId: matchedSubType || "",
              selectedSubTypes,
            },
          ],
        },
        resolve,
      );
    });
  };

  getGarageList = () => {
    const { selectedCityId } = this.state;
    if (this.props.logInUser && this.props.logInUser.id) {
      let apiUrl = `/api/garages/get?userId=${this.props.logInUser.id}&page=1&limit=50&all=true&search=`;
      if (selectedCityId) {
        apiUrl += `&garageCity=${selectedCityId}`;
      }
      return instance({
        url: apiUrl,
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          const rows = Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res)
              ? res
              : [];
          const garageList = rows.map((item) => ({
            id: item.id,
            key: item.id,
            name: item.name + " - " + item.garageNumber,
            label: item.name + " - " + item.garageNumber,
            uniqueId: item.id,
            valueType: "string",
            garageNumber: item.garageNumber,
          }));
          this.setState({ garageList });
        })
        .catch(() => {});
    }
    return Promise.resolve();
  };

  checkRequiredFields = () => {
    const { name, serviceTime, vehicles, garage, garageNumber, odometer } =
      this.state.expenseForm;
    const allExpensesValid = this.state.serviceExpenseCollection.every(
      (item) => {
        const { expenseSubTypeId, quantity } = item;
        return (
          expenseSubTypeId &&
          Object.keys(expenseSubTypeId).length > 0 &&
          parseFloat(quantity) > 0 &&
          quantity
        );
      },
    );
    const isVehiclesValid = vehicles && Object.keys(vehicles).length > 0;
    const ok =
      this.state.serviceExpenseCollection.length > 0 &&
      name &&
      odometer &&
      serviceTime &&
      isVehiclesValid &&
      (garage || garageNumber) &&
      allExpensesValid;

    this.setState({ isVisible: !ok });
  };

  handleChangeExpense = (name, value) => {
    if (name === "vehicles") {
      // locked — ignore
      return;
    }
    if (name === "garage") {
      this.setState(
        (prev) => ({
          expenseForm: {
            ...prev.expenseForm,
            garageId: value,
            garage: value,
          },
        }),
        () => this.checkRequiredFields(),
      );
      return;
    }
    if (name === "cityId") {
      this.setState(
        (prev) => ({
          expenseForm: {
            ...prev.expenseForm,
            garage: "",
            garageId: "",
            cityId: value,
          },
          selectedCityId: value?.id || null,
        }),
        () => {
          this.checkRequiredFields();
          this.getGarageList();
        },
      );
      return;
    }
    if (name === "status" || name === "workOrderNumber") {
      this.setState(
        (prev) => ({
          expenseForm: {
            ...prev.expenseForm,
            [name]: value?.target ? value.target.value : value,
          },
        }),
        () => this.checkRequiredFields(),
      );
      return;
    }
    if (name === "serviceTime" || name === "expireTime" || name === "refdate") {
      let selectedDate = value instanceof Date ? value : value?.toDate?.();
      if (name === "serviceTime" && selectedDate && !isNaN(selectedDate)) {
        const vehicleId = this.state.expenseForm?.vehicles?.id;
        const exDate = addDays(selectedDate, 7);
        this.setState(
          (prev) => ({
            expenseForm: {
              ...prev.expenseForm,
              serviceTime: selectedDate,
              expireTime: exDate,
            },
          }),
          () => {
            this.checkRequiredFields();
            if (vehicleId) this.getVehiclesData(vehicleId, selectedDate, true);
          },
        );
        return;
      }
      this.setState(
        (prev) => ({
          expenseForm: { ...prev.expenseForm, [name]: value },
        }),
        () => this.checkRequiredFields(),
      );
      return;
    }
    if (name === "sendAlert" || name === "updateMaintenance") {
      this.setState(
        (prev) => ({
          expenseForm: {
            ...prev.expenseForm,
            attributes: {
              ...prev.expenseForm.attributes,
              [name]: value,
            },
          },
        }),
        () => this.checkRequiredFields(),
      );
      return;
    }

    this.setState(
      (prev) => ({
        expenseForm: { ...prev.expenseForm, [name]: value },
      }),
      () => this.checkRequiredFields(),
    );
  };

  searchsubTypeList = async (inputValue, row, index) => {
    const array = this.state.serviceExpenseCollection;
    const expenseTypeId = array[index]?.expenseTypeId?.id;
    const selectedVehicle = this.state.expenseForm?.vehicles?.id || "";
    if (!inputValue || !expenseTypeId) return [];
    if (source) source.cancel("canceled");
    source = CancelToken.source();
    try {
      const response = await instance({
        method: "GET",
        cancelToken: source.token,
        url: `/api/expensetypes/subtype/get?expenseTypeId=${expenseTypeId}&vehicleId=${selectedVehicle}&subTypeNum=&page=1&limit=10&search=${inputValue}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      return (response?.data || []).map((item) => ({
        key: item.id,
        id: item.id,
        label: `${item.label} - ${item.subTypeNum}`,
        expenseTypeId: item.expenseTypeId,
        name: item.label,
        parentId: item.parentId,
        unitPrice: item.unitPrice,
        itemCode: item.subTypeNum,
        expenseType: item.expenseType,
      }));
    } catch (e) {
      return [];
    }
  };

  handleChangeServices = (name, value, index) => {
    const rows = [...this.state.serviceExpenseCollection];
    if (name === "expenseTypeId") {
      rows[index].expenseSubTypeId = {};
      const selectedVehicle = this.state.expenseForm?.vehicles?.id || "";
      instance({
        method: "GET",
        url: `/api/expensetypes/subtype/get?expenseTypeId=${
          value && value.id
        }&vehicleId=${selectedVehicle}&page=1&limit=10&search=`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          const res = (response?.data || []).map((item) => ({
            key: item.id,
            id: item.id,
            expenseTypeId: item.expenseTypeId,
            parentId: item.parentId,
            unitPrice: item.unitPrice,
            itemCode: item.subTypeNum,
            expenseType: item.expenseType,
            label: `${item.label} - ${item.subTypeNum}`,
            name: item.label,
          }));
          rows[index].selectedSubTypes = res;
          rows[index].expenseTypeId = value;
          this.setState({ serviceExpenseCollection: rows }, () =>
            this.checkRequiredFields(),
          );
        })
        .catch(() => {
          rows[index].expenseTypeId = value;
          rows[index].selectedSubTypes = [];
          this.setState({ serviceExpenseCollection: rows }, () =>
            this.checkRequiredFields(),
          );
        });
      return;
    }
    if (name === "expenseSubTypeId") {
      rows[index].cost = value?.unitPrice !== 0 ? value.unitPrice : 0;
    }
    if (name === "quantity" && value > 0) {
      const unit = parseFloat(rows[index]?.expenseSubTypeId?.unitPrice || 0);
      rows[index].cost = unit ? unit * parseFloat(value) : rows[index].cost;
    }
    rows[index][name] = value;
    this.setState({ serviceExpenseCollection: rows }, () =>
      this.checkRequiredFields(),
    );
  };

  addMore = () => {
    this.setState((prev) => ({
      serviceExpenseCollection: [
        ...prev.serviceExpenseCollection,
        {
          expenseSubTypeId: "",
          quantity: "1",
          cost: "1",
          expenseTypeId: "",
          selectedSubTypes: [],
        },
      ],
    }));
  };

  deleteRow = (row, index) => {
    const rows = [...this.state.serviceExpenseCollection];
    rows.splice(index, 1);
    this.setState({ serviceExpenseCollection: rows }, () =>
      this.checkRequiredFields(),
    );
  };

  uploadExpenseAttachment = (event) => {
    const file = event?.target?.files?.[0];
    if (event?.target) event.target.value = "";
    if (!file) return;
    const allowed = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/webp",
      "application/pdf",
    ];
    if (!allowed.includes(file.type)) {
      this.props.dispatch(notifyError("onlyAcceptImagesDocs"));
      return;
    }
    if (file.size / (1024 * 1024) > 2) {
      this.props.dispatch(notifyError("fileSize2MB"));
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      this.setState((prev) => ({
        expenseForm: { ...prev.expenseForm, files: e.target.result },
      }));
    };
    reader.readAsDataURL(file);
  };

  removeExpenseAttachment = () => {
    this.setState((prev) => ({
      expenseForm: { ...prev.expenseForm, files: "" },
    }));
  };

  uploadFile = () => {
    this.submitExpense();
  };

  submitExpense = () => {
    let totalQuantity = 0;
    let totalCost = 0;
    const newFile1 = [];
    const isPrepaid =
      this.state.expenseForm?.prePaid === true ||
      this.state.expenseForm?.prePaid === "true" ||
      this.state.expenseForm?.prepaid === true ||
      this.state.expenseForm?.prepaid === "true";
    const tapWindow = isPrepaid ? window.open("about:blank", "_blank") : null;

    (this.state.serviceExpenseCollection || []).forEach((item) => {
      if (item.quantity && item.expenseSubTypeId?.id) {
        totalCost += parseFloat(item.cost);
        totalQuantity += parseInt(item.quantity, 10);
        const unitPrice = parseFloat(item.expenseSubTypeId.unitPrice) || 0;
        const clean = { ...item };
        delete clean.type;
        delete clean.e;
        delete clean.selectedSubTypes;
        delete clean.allExpenseTypes;
        newFile1.push({
          ...clean,
          serviceId: 0,
          cost: parseFloat(item.cost),
          unitPrice,
          expenseSubTypeId: item.expenseSubTypeId.id,
          expenseTypeId: item.expenseTypeId.id,
          subTypeLabel: item.expenseSubTypeId.name,
          subTypeNum: item.expenseSubTypeId.itemCode,
          typeLabel:
            item.expenseTypeId.label === "packages" ||
            item.expenseTypeId.name === "packages" ||
            item.expenseTypeId.label === "services" ||
            item.expenseTypeId.name === "services" ||
            item.expenseTypeId.label === "items" ||
            item.expenseTypeId.name === "items"
              ? "contract"
              : "spot",
          expenseType:
            item.expenseTypeId.label === "packages" ||
            item.expenseTypeId.name === "packages" ||
            item.expenseTypeId.label === "services" ||
            item.expenseTypeId.name === "services" ||
            item.expenseTypeId.label === "items" ||
            item.expenseTypeId.name === "items"
              ? item.expenseTypeId?.name || item.expenseTypeId.label
              : item.expenseSubTypeId.expenseType,
        });
      }
    });

    this.setState({ serviceExpenseCollection: newFile1, loader: true }, () => {
      const obj = DataFormat(
        this.state.expenseForm,
        totalCost,
        totalQuantity,
        this.state.serviceExpenseCollection,
        this.props.ServerSetting,
        this.props.logInUser.customerType,
      );
      const url =
        this.props.logInUser.customerType === 1 ||
        this.props.logInUser.customerType === 2
          ? `/api/services/estimate`
          : `/api/services/?zerovat=${this.state.zerovat}&issueinvoice=${this.state.issueinvoice}`;

      instance({
        url,
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: { ...obj },
      })
        .then((response) => {
          this.props.dispatch(notifySuccess("requestCreated"));
          const prepaid =
            this.state.expenseForm?.prePaid === true ||
            this.state.expenseForm?.prePaid === "true" ||
            this.state.expenseForm?.prepaid === true ||
            this.state.expenseForm?.prepaid === "true";
          const bookingId =
            response?.id ||
            response?.service?.id ||
            response?.serviceId ||
            response?.bookingId ||
            null;

          const finish = () => {
            this.setState({ loader: false });
            if (this.props.onSuccess) this.props.onSuccess();
            this.props.onClose();
          };

          if (prepaid && bookingId) {
            initiateBookingTapPayment({
              dispatch: this.props.dispatch,
              ServerSetting: this.props.ServerSetting,
              logInUser: this.props.logInUser,
              bookingId,
              amount: totalCost,
              description: this.state.expenseForm?.name || "",
              tapWindow,
            })
              .catch(() => {})
              .finally(() => finish());
          } else {
            if (tapWindow && !tapWindow.closed) tapWindow.close();
            finish();
          }
        })
        .catch((error) => {
          if (tapWindow && !tapWindow.closed) tapWindow.close();
          this.setState({ loader: false });
          errorHandler(error, this.props.dispatch);
        });
    });
  };

  handleChangeVAT = (name, value) => {
    this.setState({ [name]: value });
  };

  saveToParent = (obj) => {
    this.setState((prev) => ({
      expenseForm: {
        ...prev.expenseForm,
        attributes: { ...prev.expenseForm.attributes, ...obj },
      },
    }));
  };

  noop = () => {};

  render() {
    const { translate, themecolors, logInUser, ServerSetting, dispatch } =
      this.props;

    return (
      <CustomDialog
        disableCloseBtn
        onClose={this.props.onClose}
        title={translate("addBooking") || "Add Booking"}
        maxWidth="lg"
        fullWidth
        isVisableBtn
        cancelText={translate("sharedCancel") || "Cancel"}
      >
        <div style={{ padding: "10px" }}>
          {this.state.loading ? (
            <Loader defaultStyle />
          ) : (
            <CreateExpense
              lockVehicle
              embedded
              searchsubTypeList={this.searchsubTypeList}
              defaultAccountsList={[]}
              handleChangeVAT={this.handleChangeVAT}
              issueinvoice={this.state.issueinvoice}
              zerovat={this.state.zerovat}
              expenseForm={this.state.expenseForm}
              vehicleTracker={null}
              selectedUnit={null}
              isVisible={this.state.isVisible}
              serviceExpenseCollection={this.state.serviceExpenseCollection}
              selectedVehilcesList={this.state.vehicles}
              mode={false}
              image64Type={[]}
              loader={this.state.loader}
              dueActive={false}
              drivers={this.state.drivers}
              garageList={this.state.garageList}
              statusTypes={[]}
              statusTypes1={[]}
              ServerSetting={ServerSetting}
              notificationMode="create"
              saveToParent={this.saveToParent}
              dispatch={dispatch}
              vehicles={this.state.vehicles}
              subTypes={[]}
              expenseType={this.state.expenseTypes}
              themecolors={themecolors}
              translate={translate}
              logInUser={logInUser}
              completeMode={false}
              handleChangeExpense={this.handleChangeExpense}
              onChangedDevice={this.noop}
              closeExpense={this.props.onClose}
              closeCreateFrom={this.props.onClose}
              submitExpense={this.submitExpense}
              addMore={this.addMore}
              uploadImage={this.noop}
              uploadExpenseAttachment={this.uploadExpenseAttachment}
              removeExpenseAttachment={this.removeExpenseAttachment}
              handleChangeServices={this.handleChangeServices}
              deleteRow={this.deleteRow}
              imagePopup={this.noop}
              uploadFile={this.uploadFile}
              deleteImage={this.noop}
              showDueMaintenance={this.noop}
              showDialogBtn={false}
              vehicleDueMaintenance={[]}
              showDueDialog={false}
              showDueMaintenanceDialogFunc={this.noop}
              onCloseDueMaintenanceModel={this.noop}
              handleChangePage={this.noop}
              handleChangeRowsPerPage={this.noop}
              setDuePagination={this.noop}
              check={false}
              areaList={[]}
              tab="due"
              isValidVehicle={this.state.isValidVehicle}
              selectedCityId={this.state.selectedCityId}
            />
          )}
        </div>
      </CustomDialog>
    );
  }
}

export default connect((state) => ({
  cities: state.Cities.cities,
}))(ScheduleBookingModal);
